export default __webpack_public_path__ + "static/media/close.61a02b64.svg";